const en_sales_returncustomer = {
    "": "customer return",
    type: "return method",

    label: {
        ref_itemout: "goods issue reference",
        no_trans_out: "goods issue transaction number",
    },

    error: {
        create: "Failed to create customer return.",
        edit: "Failed to update customer return.",
        type: "Return type cannot be empty.",
        sn_not_found: "Item with serial number {{sn}} is still in the warehouse or not yet registered.",
    },

    success: {
        create: "Customer return created successfully.",
        edit: "Customer return updated successfully.",
    },
}

export default en_sales_returncustomer;